import { useSelector } from 'react-redux';

// TODO: This import prevents Admin from compiling, hardcoding the constant below for now
// import { BankAccountsCacheKey } from '../../../../../../../../apps/manager/src/services/cache/actions/accounting';
import SelectFilter from 'Lib/muiComponents/common/SelectFilter';

export default function BankAccount(props) {
    const bankAccounts = useSelector(state => state.dataCache['accounting/BankAccounts']);
    const options = bankAccounts?.data?.data?.map(item => ({
        label: `${item.account.number}: ${item.account.name}`,
        value: item.account.accountID
    }));

    if (!options) return null;

    return (
        <SelectFilter
            multi={props.multi}
            value={props.value}
            label={props.label}
            placeholder="Type to search bank account"
            options={options}
            onChange={(__, options) => props.onChange(props.name, options)}
        />
    );
}
